<template>
  <div class="plot-maker-page">
    <iframe :src="frameSrc" class="plot-maker-frame" allow="fullscreen 'self'" />
  </div>
</template>

<script lang="ts">
import { Dialog } from "@/lib/utils";
import { SimpleDialogProps } from "@@/ui/SimpleDialog.vue";
import SimpleDialog from "@/components/ui/SimpleDialog.vue";

import Vue from "vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    novelId: String,
    plotMakerId: String,
  },
  computed: {
    frameSrc() {
      const sampleParams = new URLSearchParams();
      sampleParams.set("novelId", this.novelId);
      if (this.plotMakerId) {
        sampleParams.set("plotMakerId", this.plotMakerId);
      }
      return `/inline-frame/plot-maker?${sampleParams.toString()}`;
    },
  },
  methods: {
    beforeLeave(e: BeforeUnloadEvent) {
      // iframe内のisModifiedがtrueの場合は確認ダイアログを表示する
      const { isModified } = (document.querySelector(".plot-maker-frame") as HTMLIFrameElement).contentWindow as any;
      if (isModified) {
        e.preventDefault();
        e.returnValue = "";
        return "";
      }
      return undefined;
    },
    showLeaveConfirmDialog(next) {
      const confirmDialog = new Dialog(SimpleDialog);
      const options: SimpleDialogProps = {
        title: "保存していないデータが存在します。",
        content: "保存されていないデータは破棄されます。\nこのまま画面遷移しますか？",
        negative: "キャンセル",
        positive: "遷移する",
        positiveCallback: () => {
          next();
        },
      };

      confirmDialog.show(options);
    },
  },
  mounted() {
    window.addEventListener("beforeunload", this.beforeLeave);
    document.documentElement.classList.add("plot-maker-page");
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.beforeLeave);
    document.documentElement.classList.remove("plot-maker-page");
  },

  beforeRouteLeave(to, from, next) {
    const { isModified } = (document.querySelector(".plot-maker-frame") as HTMLIFrameElement).contentWindow as any;
    if (!isModified) {
      next();
      return;
    }

    this.showLeaveConfirmDialog(next);
  },
});

interface Props {
  novelId: string;
  plotMakerId?: string;
}

interface Data {}

interface Computed {
  frameSrc: string;
}

interface Methods {
  beforeLeave(e: Event): any;
  showLeaveConfirmDialog(next: any): void;
}
</script>

<style lang="scss">
html.plot-maker-page {
  /**
    * デフォルトではChromeでは2本指のスワイプでページを戻る／進む動作が割り当ており、横スクロール時に誤って発動すると操作性が悪くなるため
    * プロットメーカーのページ内でオーバースクロール時の動作を無効化することでページ遷移を防ぐ
     */
  overscroll-behavior-x: none;
}
</style>

<style lang="scss" scoped>
.plot-maker-page {
  width: 100%;
  /** 上下に細かいスクロールが発生しないように高さを少し小さくしておく */
  height: calc(100% - 6px);
  background: url("~@/assets/img/loading-s.gif") no-repeat center center;
  background-color: var(--color-background-normal);

  .plot-maker-frame {
    width: 100%;
    height: 100%;
    border: none;
  }

  @include mq(sp) {
    /** フッターメニューの高さを引いておく */
    height: calc(100vh - 50px);
  }
}
</style>
